import { useEffect, useState } from "react";

export default function LiveCount() {
  const [n, setN] = useState(() => Math.floor(Math.random() * 8) + 6);
  useEffect(() => {
    const t = setInterval(() => setN(c => Math.max(4, Math.min(20, c + (Math.random() > .55 ? (Math.random() > .5 ? 1 : -1) : 0)))), 7000);
    return () => clearInterval(t);
  }, []);
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "rgba(34,197,94,.1)", border: "1px solid rgba(34,197,94,.22)", borderRadius: 20, padding: "4px 12px", fontSize: 12, fontWeight: 600, color: "#15803d", marginBottom: 14 }}>
      <span style={{ width: 6, height: 6, background: "#22c55e", borderRadius: "50%", animation: "pulse 1.5s infinite", flexShrink: 0 }} />
      {n} people viewing lab products right now
    </div>
  );
}
